<vs-dialog #dialog [config]="{ dialogContainerClass: 'max-w-[500px]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      icon: 'alert-triangle',
      iconTheme: 'danger',
      title: 'Delete Element',
      subtitle: 'Are you sure you want to delete <strong>' + (element?.title || 'this element') + '</strong>? This action cannot be undone.'
    }"
  ></vs-dialog-header>

  <vs-alert *ngIf="hasChildren" theme="danger" class="mb-4">
    <div class="flex items-start gap-2">
      <vs-icon name="alert-triangle" size="16" class="mt-0.5"></vs-icon>
      <div>
        <p class="text-sm font-semibold">This element has child elements</p>
        <p class="text-sm mt-1">Deleting this element will also delete all its child elements and their descendants.</p>
      </div>
    </div>
  </vs-alert>

  <div class="flex gap-2">
    <button vs-button appearance="outline" class="flex-1" (click)="cancel()" [disabled]="deleting">Cancel</button>
    <button vs-button theme="danger" class="flex-1" (click)="delete()" [disabled]="deleting">
      <vs-icon slot="start" [class.animate-spin]="deleting" [name]="deleting ? 'refresh-cw-04' : 'trash-01'"></vs-icon>
      {{ deleting ? 'Deleting...' : 'Delete' }}
    </button>
  </div>
</vs-dialog>
